module.exports = __webpack_public_path__ + "img/5-3.b36c4f04.jpg";